import { Container } from "react-bootstrap";
import { useState } from "react";
import realProfile from "../assets/img/profile-swe.png";
import { Helmet, HelmetProvider } from "react-helmet-async";
import { TypeAnimation } from 'react-type-animation';
import "./CSS/Home.css";

function Home() {
  const [showSubtitle, setShowSubtitle] = useState(false);

  return (
    <>
      <HelmetProvider>
        <Helmet>
          <title>Welcome! | Lee</title>
        </Helmet>
      </HelmetProvider>
      <Container fluid className="home-wrapper">
        <div className="home-left animate__animated animate__fadeInLeft">
              <TypeAnimation 
                cursor={false}
                sequence={[
                  'Welcome to my \ndigital realm!'
                    , 
                  () => setShowSubtitle(true)
                ]}
                speed={{ type: "keyStrokeDelayInMs", value: 120 }}
                wrapper="h2"
                repeat={0}
                className="display-linebreak"
              />
              {showSubtitle &&
              <>
              <div className="home-subtitle-container"><h3 className="home-subtitle"> </h3>
                <TypeAnimation
                  cursor={true}
                  sequence={[
                    'I design systems with purpose.',
                    1000,
                    'I focus on data and behaviour.',
                    1000,
                    'I build software meant to last.',
                    1000,
                  ]}
                  speed={50}
                  deletionSpeed={65}
                  wrapper="h3"
                  repeat={Infinity}
                  className="home-subtitle"
                />
               </div> 
              </>
              }
          <a href="mailto:lee@zlaliberte.com" className="btn-connect text-center">
            Let's Connect
          </a>
        </div>
        <div className="home-right animate__animated animate__fadeIn animate__slower">
          <img
            className="home-image"
            src={realProfile}
            alt="Avatar"
          />
        </div>
      </Container>
    </>
  );
}

export default Home;
